var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module_scheme_thumb",attrs:{"title":_vm.url ? '' : 'В схеме нет модулей'}},[(_vm.url && !_vm.failed)?_c('img',{attrs:{"src":_vm.url,"alt":"","loading":"lazy"},on:{"error":function($event){_vm.failed = true}}}):_c('span',{staticClass:"module_scheme_thumb__empty"},[_vm._v("—")])])
}
var staticRenderFns = []

export { render, staticRenderFns }